<script setup>
import { computed } from 'vue'

/**
 * Every image on the page goes through here so intrinsic dimensions and a
 * loading strategy are impossible to forget — both are required props.
 */
const props = defineProps({
  src: { type: String, required: true },
  alt: { type: String, required: true },
  width: { type: Number, required: true },
  height: { type: Number, required: true },
  /** `eager` only for the LCP hero image. */
  loading: {
    type: String,
    default: 'lazy',
    validator: (value) => ['lazy', 'eager'].includes(value)
  },
  /** Purely decorative images pass alt="" and are hidden from assistive tech. */
  decorative: { type: Boolean, default: false }
})

const fetchPriority = computed(() => (props.loading === 'eager' ? 'high' : 'auto'))
const ratio = computed(() => `${props.width} / ${props.height}`)
</script>

<template>
  <img
    :src="src"
    :alt="decorative ? '' : alt"
    :aria-hidden="decorative ? 'true' : undefined"
    :width="width"
    :height="height"
    :loading="loading"
    :fetchpriority="fetchPriority"
    decoding="async"
    :style="{ aspectRatio: ratio }"
  />
</template>
